import { render } from "./BlogFooter.vue?vue&type=template&id=bdf21272&scoped=true"
import script from "./BlogFooter.vue?vue&type=script&lang=js"
export * from "./BlogFooter.vue?vue&type=script&lang=js"

import "./BlogFooter.vue?vue&type=style&index=0&id=bdf21272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf21272"]])

export default __exports__